/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * List investor classes.
 */
export const investorClassListParams = zod.object({
  "fundFamilyId": zod.string()
})

export const investorClassListQueryParams = zod.object({
  "investor_entity_id": zod.string().optional()
})

/**
 * Create investor class.
 */
export const investorClassCreateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const investorClassCreateBody = zod.object({
  "name": zod.string().min(1),"notes": zod.string().optional(),"fund_family_id": zod.string().min(1)
})

/**
 * Get investor class by id.
 */
export const investorClassRetrieveParams = zod.object({
  "fundFamilyId": zod.string(),"investorClassId": zod.string()
})

export const investorClassRetrieveResponseAnnotationsSetMin = 2;
export const investorClassRetrieveResponseAnnotationsSetMax = 2;

export const investorClassRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(investorClassRetrieveResponseAnnotationsSetMin).max(investorClassRetrieveResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"notes": zod.string().optional(),"id": zod.string().min(1),"fund_family_id": zod.string().min(1),"fund_family_event_id": zod.string().min(1)
})

/**
 * Update investor class by id.
 */
export const investorClassUpdateParams = zod.object({
  "fundFamilyId": zod.string(),"investorClassId": zod.string()
})

export const investorClassUpdateBody = zod.object({
  "name": zod.string().min(1),"notes": zod.string().optional()
})

export const investorClassUpdateResponseAnnotationsSetMin = 2;
export const investorClassUpdateResponseAnnotationsSetMax = 2;

export const investorClassUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(investorClassUpdateResponseAnnotationsSetMin).max(investorClassUpdateResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"notes": zod.string().optional(),"id": zod.string().min(1),"fund_family_id": zod.string().min(1),"fund_family_event_id": zod.string().min(1)
})

